/* Stage selezionato
null | {"value": stage, ...}
*/
import { createContext } from "react";
const SelectedStageContext = createContext({
    selectedStage: null,
    setSelectedStage: (stage) => {}
  });
export default SelectedStageContext;